var map = {
	"./": [
		20,
		9
	],
	"./Home/Page": [
		36,
		9,
		0,
		2
	],
	"./Home/Page/": [
		36,
		9,
		0,
		2
	],
	"./Home/Page/index": [
		36,
		9,
		0,
		2
	],
	"./Home/Page/index.js": [
		36,
		9,
		0,
		2
	],
	"./Home/Page/policy": [
		66,
		9,
		1,
		0,
		4
	],
	"./Home/Page/policy.js": [
		66,
		9,
		1,
		0,
		4
	],
	"./Home/Page/rules": [
		67,
		9,
		1,
		0,
		5
	],
	"./Home/Page/rules.js": [
		67,
		9,
		1,
		0,
		5
	],
	"./Home/Store/initReducer": [
		27,
		9
	],
	"./Home/Store/initReducer.js": [
		27,
		9
	],
	"./Home/Store/initSagas": [
		28,
		9
	],
	"./Home/Store/initSagas.js": [
		28,
		9
	],
	"./Home/assets/images/logo.png": [
		123,
		9,
		8
	],
	"./Home/assets/images/logoText.png": [
		119,
		9,
		9
	],
	"./Home/assets/svg": [
		37,
		9,
		3
	],
	"./Home/assets/svg/": [
		37,
		9,
		3
	],
	"./Home/assets/svg/algea.svg": [
		124,
		9,
		10
	],
	"./Home/assets/svg/app-store.svg": [
		120,
		9,
		11
	],
	"./Home/assets/svg/bear.svg": [
		125,
		9,
		12
	],
	"./Home/assets/svg/buy-now.svg": [
		122,
		9,
		13
	],
	"./Home/assets/svg/chplay.svg": [
		121,
		9,
		14
	],
	"./Home/assets/svg/desktop-bg.svg": [
		126,
		9,
		15
	],
	"./Home/assets/svg/fish.svg": [
		127,
		9,
		16
	],
	"./Home/assets/svg/index": [
		37,
		9,
		3
	],
	"./Home/assets/svg/index.js": [
		37,
		9,
		3
	],
	"./Home/assets/svg/logo.svg": [
		128,
		9,
		17
	],
	"./Home/assets/svg/mobile-bg.svg": [
		129,
		9,
		18
	],
	"./Home/assets/svg/tablet-bg.svg": [
		130,
		9,
		19
	],
	"./Home/assets/svg/water-face.svg": [
		131,
		9,
		20
	],
	"./Home/bootstrap": [
		39,
		9
	],
	"./Home/bootstrap.js": [
		39,
		9
	],
	"./Home/bootstrap.scss": [
		117,
		7,
		21
	],
	"./Home/configs/api": [
		68,
		9,
		6
	],
	"./Home/configs/api.js": [
		68,
		9,
		6
	],
	"./Home/configs/constants": [
		69,
		7,
		7
	],
	"./Home/configs/constants.js": [
		69,
		7,
		7
	],
	"./Home/i18n/localization/en": [
		25,
		3
	],
	"./Home/i18n/localization/en.json": [
		25,
		3
	],
	"./Home/i18n/localization/vi": [
		26,
		3
	],
	"./Home/i18n/localization/vi.json": [
		26,
		3
	],
	"./Home/responsive.scss": [
		118,
		7,
		22
	],
	"./index": [
		20,
		9
	],
	"./index.js": [
		20,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 101;
module.exports = webpackAsyncContext;